import { render, staticRenderFns } from "./vacancies-section.vue?vue&type=template&id=2d7d01e8"
import script from "./vacancies-section.vue?vue&type=script&lang=js"
export * from "./vacancies-section.vue?vue&type=script&lang=js"
import style0 from "./vacancies-section.vue?vue&type=style&index=0&id=2d7d01e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports